export default class Fornecedor {
  constructor(id, nome, cnpj, endereco, bairro, cidade, uf, telefone, email) {
    this.id = id;
    this.nome = nome;
    this.cnpj = cnpj;
    this.endereco = endereco;
    this.bairro = bairro;
    this.cidade = cidade;
    this.uf = uf;
    this.telefone = telefone;
    this.email = email;
  }
}
